const datesKeys = ["fromDatePublished", "toDatePublished"];

export function truncateString(str, num) {
  if (str.length > num) {
    return str.slice(0, num) + "...";
  } else {
    return str;
  }
}

export function jsonToCsv(items) {
  const header = Object.keys(items[0]);
  const headerString = header.join(',');
  // handle null or undefined values here
  const replacer = (key, value) => value ?? '';
  const rowItems = items.map((row) =>
    header
      .map((fieldName) => JSON.stringify(row[fieldName], replacer))
      .join(',')
  );
  // join header and body, and break into separate lines
  const csv = [headerString, ...rowItems].join('\r\n');
  return csv;
}

export function searchParamsBuilder(list, page = 0, filters = {}) {
  const queryList = [];
  list.forEach((element) => {
    queryList.push([
      element.attribute.length ? element.attribute : "everywhere",
      element.query,
    ]);
  });
  queryList.push(["pageNumber", page]);
  if (Object.keys(filters).length) {
    Object.keys(filters).forEach((key) => {
      // console.log(key, filters[key])
      if(datesKeys.includes(key)) {
        queryList.push([key, filters[key]])
      } else {
        filters[key].forEach((val) => queryList.push([key, val]));
      }
    });
  }
  return queryList;
}

export function searchParamsReader(entries) {
  const urlParamsList = [];
  let page = 0;
  const filtersMap = {};
  const guardedAttributed = [
    "everywhere",
    "itemTitle",
    "author",
    "publication",
  ];
  const keyMapping = {
    everywhere: "",
    itemTitle: "itemTitle",
    author: "authors",
    publication: "publications",
  };
  for (const [key, value] of entries) {
    if (key === "pageNumber") {
      page = Number(value);
    } else if (guardedAttributed.includes(key)) {
      urlParamsList.push({
        query: value,
        attribute: keyMapping[key],
      });
    } else {
      if (datesKeys.includes(key)) {
        if (!filtersMap[key]) {
          filtersMap[key] = value;
        }
      } else {
        if (!filtersMap[key]) {
          filtersMap[key] = [];
        }
        filtersMap[key].push(value);
      }
    }
  }

  return { queries: urlParamsList, pageNumber: page, filters: filtersMap };
}

export function advanceQueryChecker(list) {
  if (list.length === 1) {
    return !!list[0].attribute.length;
  }
  return list.length > 1;
}

export function findIndexOfObjectWithPropertyValue(
  arrayOfObjects,
  attributeValue,
  queryValue
) {
  for (let i = 0; i < arrayOfObjects.length; i++) {
    if (
      arrayOfObjects[i]["attribute"] === attributeValue &&
      arrayOfObjects[i]["query"] === queryValue.toLowerCase()
    ) {
      return i; // Return the index of the first matching object
    }
  }
  return -1; // Return -1 if no matching object is found
}

export function dateArrayBuilder(
  minMonth = 0,
  minYear = 2019,
  isBefore = false
) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const d = new Date();
  const currentYear = d.getFullYear();
  const currentMonth = d.getMonth();
  const currentDay = d.getDay();
  let startingMonth = minMonth;
  let maxMonth = 11;
  const results = [];
  for (let y = minYear; y <= currentYear; y++) {
    if (y > minYear) {
      startingMonth = 0;
    }
    if (y === currentYear) maxMonth = currentMonth;
    for (let m = startingMonth; m <= maxMonth; m++) {
      const valueM = m < 9 ? `0${m + 1}` : m + 1;
      results.push({
        label: `${months[m]} - ${y}`,
        value: `${y}-${valueM}-01`,
      });
    }
  }
  if (isBefore) {
    results.push({
      label: `Today`,
      value: `${currentYear}-${
        currentMonth < 9 ? `0${currentMonth + 1}` : currentMonth + 1
      }-${currentDay}`,
    });
  }
  return results;
}
